<ng-container *ngIf="viewModel$ | async as viewModel">
    <div>
        <ng-template #product>
            <div>
                <p-autoComplete
                    field="name"
                    [ngModel]="viewModel.productName"
                    #productModel="ngModel"
                    [suggestions]="viewModel.productSuggestions"
                    (onSelect)="store.dispatch(actions.productSelected({ selectedProduct: $event.value }))"
                    (onKeyUp)="store.dispatch(actions.productAutocompleteInputChanged({ value: $event.target.value }))"
                    appendTo="body"
                    required
                >
                    <ng-template
                        pTemplate="item"
                        let-product
                    >
                        {{ product.name }}
                    </ng-template>

                </p-autoComplete>
                <app-validation-messages
                    [control]="productModel.control"
                    [requireTouched]="true"
                ></app-validation-messages>
            </div>
        </ng-template>

        <ng-template #description>
            <div>
                <input
                    type="text"
                    pInputText
                    [ngModel]="viewModel.description"
                    #descriptionModel="ngModel"
                    (ngModelChange)="store.dispatch(actions.descriptionInputChanged({ value: $event }))"
                />
            </div>
        </ng-template>

        <ng-template #amount>
            <div *ngIf="!viewModel.isPercentCharge">
                <p-inputNumber
                    [ngModel]="viewModel.amount"
                    #fixedAmountModel="ngModel"
                    [currency]="viewModel.currency"
                    [disabled]="viewModel.amountDisabled"
                    (onInput)="store.dispatch(actions.fixedAmountInputChanged({ amount: $event.value }))"
                    (onBlur)="store.dispatch(actions.fixedAmountInputBlurred())"
                    mode="currency"
                    required
                ></p-inputNumber>
                <br>
                <small *ngIf="viewModel.amountDisabled">The amount has been set to the active price on the product.</small>
                <app-validation-messages
                    [control]="fixedAmountModel.control"
                    [requireTouched]="true"
                ></app-validation-messages>
            </div>
            <div *ngIf="viewModel.isPercentCharge">
                <p-inputNumber
                    *ngIf="viewModel.isPercentCharge"
                    [currency]="viewModel.currency"
                    [ngModel]="viewModel.amount"
                    #percentageAmountModel="ngModel"
                    [disabled]="viewModel.amountDisabled"
                    (onInput)="store.dispatch(actions.percentageAmountInputChanged({ amount: $event.value }))"
                    suffix="%"
                    required
                ></p-inputNumber>
                <br>
                <small *ngIf="viewModel.amountDisabled">The amount has been set to the active price on the product.</small>
                <app-validation-messages
                    [control]="percentageAmountModel.control"
                    [requireTouched]="true"
                ></app-validation-messages>
            </div>
        </ng-template>

        <ng-template #quantity>
            <div>
                <p-inputNumber
                    [suffix]="viewModel.productUnitLabel"
                    min="0.01"
                    [minFractionDigits]="1"
                    [maxFractionDigits]="2"
                    [showButtons]="true"
                    [ngModel]="viewModel.quantity"
                    #quantityModel="ngModel"
                    (onInput)="store.dispatch(actions.quantityInputChanged({ quantity: $event.value }))"
                    required
                    [class.p-invalid-input]="quantityModel.invalid && quantityModel.touched"
                ></p-inputNumber>
                <app-validation-messages
                    [control]="quantityModel.control"
                    [requireTouched]="true"
                ></app-validation-messages>
            </div>
        </ng-template>

        <ng-template #event>
            <app-job-event-select
                [ngModel]="viewModel.eventIds"
                (ngModelChange)="store.dispatch(actions.eventSelected({ eventIds: $event }))"
                #eventsModel="ngModel"
                [appArrayMinLength]="1"
            ></app-job-event-select>
            <app-validation-messages
                [control]="eventsModel.control"
                [requireTouched]="true"
            ></app-validation-messages>
        </ng-template>

        <ng-template #taxes>
            <div
                class="p-grid"
            >
                <div class="p-col">
                    <p-multiSelect
                        [options]="viewModel.taxOptions"
                        class="full-width-multiselect"
                        [ngModel]="viewModel.taxes"
                        (onChange)="store.dispatch(actions.taxesSelectionChanged({ taxes: $event.value }))"
                        [showToggleAll]="false"
                        optionLabel="name"
                        dataKey="id"
                        [maxSelectedLabels]="1"
                        [selectedItemsLabel]="'{0} Taxes Selected'"
                        [autofocusFilter]="!responsiveHelper.isSmallScreen"
                        appendTo="body"
                    >
                        <ng-template
                            let-tax
                            pTemplate="item"
                        >
                            <div> <div>{{tax.name}}</div>
                            </div>
                        </ng-template>
                    </p-multiSelect>
                </div>
                <div class="p-col">
                    <span class="chip-container">
                        <p-chip
                            *ngFor="let tax of viewModel.taxes"
                            [removable]="true"
                            (onRemove)="store.dispatch(actions.removeTaxButtonClicked({ taxId: tax.id }))"
                            [label]="tax.name"
                        >
                        </p-chip>
                    </span>
                </div>
            </div>
        </ng-template>
        <!-- TODO: Create a reusable component for this (used in mutate-charges and mutate-prices) -->
        <ng-template #expenses>
            <div
                class="p-datatable"
            >
                <table
                    style="width: 100%;"
                    class="p-datatable-table"
                >
                    <thead class="p-datatable-thead">
                        <tr>
                            <th style="min-width: 14rem;">Name</th>
                            <th>Unit Cost {{singularProductUnit}} </th>
                            <th>Total Cost</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody class="p-datatable-tbody">
                        <tr *ngFor="let expense of viewModel.expenses; index as ri; trackBy: trackByIndex">
                            <td>
                                <p-dropdown
                                    [options]="viewModel.expenseOptions"
                                    appendTo="body"
                                    placeholder="Select Cost"
                                    [ngModel]="expense.expenseId"
                                    (onChange)="store.dispatch(actions.expenseSelected({ expenseId: $event.value, index: ri }))"
                                    optionLabel="name"
                                    optionValue="id"
                                    required
                                ></p-dropdown>
                            </td>
                            <td>
                                <p-inputNumber
                                    [ngModel]="expense.unitCost"
                                    (onInput)="store.dispatch(actions.unitCostInputChanged({ unitCost: $event.value, index: ri }))"
                                    inputId="currency-us"
                                    mode="currency"
                                    [currency]="viewModel.currency"
                                    locale="en-US"
                                    [ngClass]="{}"
                                    required
                                />
                            </td>
                            <td>
                                {{ expense.total | currency: viewModel.currency }}
                            </td>
                            <td>
                                <p-button
                                    icon="pi pi-trash"
                                    severity="danger"
                                    size="small"
                                    (click)="store.dispatch(actions.removeExpenseButtonClicked({ index: ri }))"
                                />
                            </td>
                        </tr>
                    </tbody>
                    <tfoot class="p-datatable-tfoot">
                        <tr>
                            <td colspan="3">
                                <p-button
                                    label="Add Cost"
                                    icon="pi pi-plus"
                                    size="small"
                                    [outlined]="true"
                                    (click)="store.dispatch(actions.addExpenseButtonClicked())"
                                ></p-button>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </ng-template>
    </div>

    <app-job-mutate-object
        mutateObjectType="charge"
        [steps]="viewModel.steps"
        [templates]="templates"
        scrollHeight="300px"
    ></app-job-mutate-object>
</ng-container>
